var path = '/var/www/mmscny-cms/src/app/common/components/google-location/google-location.html';
var html = "<div class=\"form-group contForm phone-div location-text-input\"> <input type=text id=location class=form-control ng-change=$ctrl.onLocationChange() ng-class=\"{'error-input': $ctrl._isError}\" placeholder=\"Enter Service Area\" ng-model=$ctrl.locationName ng-disabled=$ctrl._isDisabledLocation ng-required=$ctrl._isRequired /> <span class=clear-input ng-click=$ctrl.clearLocationInput() ng-if=$ctrl._isDisabledLocation>X</span> <p ng-if=$ctrl._isError class=error>Invalid location: address should have at least county</p> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/google-location/google-location.html
// module id = 728
// module chunks = 0